module.exports = __webpack_public_path__ + "static/media/mobileCityPreview.7f6dd4c3.JPG";